export const ADMIN_CLIENTS_GET_ALL_REQUESTING =
  "ADMIN_CLIENTS_GET_ALL_REQUESTING";
export const ADMIN_CLIENTS_GET_ALL_SUCCESS = "ADMIN_CLIENTS_GET_ALL_SUCCESS";
export const ADMIN_CLIENTS_GET_ALL_ERROR = "ADMIN_CLIENTS_GET_ALL_ERROR";
export const ADMIN_SET_FAKE_DATA = "ADMIN_SET_FAKE_DATA";
